/**
 * 全局工具函数插件
 * 将常用工具函数注册到Vue全局
 */

import pxToRem, { remToPx, convertStyles } from '@/utils/px-to-rem';

const GlobalUtilsPlugin = {
  install: (app) => {
    // 注册到全局属性
    app.config.globalProperties.$pxToRem = pxToRem;
    app.config.globalProperties.$remToPx = remToPx;
    app.config.globalProperties.$convertStyles = convertStyles;
    
    // 也可以添加到window对象，在非Vue环境中也能使用
    if (typeof window !== 'undefined') {
      window.$pxToRem = pxToRem;
      window.$remToPx = remToPx;
      window.$convertStyles = convertStyles;
    }
  }
};

export default GlobalUtilsPlugin;